<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader

    main
      v-container.text-xs-center.primary--text
        h1 お問い合わせ
        v-layout(row wrap)
          v-flex(xs12)
            img.my-5(src="static/images/trading_logo.png" alt="大谷商会ロゴ")
            p.mb-1 【輸入販売元】
            h3.mb-3 株式会社大谷商会 国際部
            address.my-2 〒950-0814 新潟県新潟市東区逢谷内463
              br
              span TEL 025-275-8185
              span.mr-1 FAX 025-275-8186
            a.primary--text(href="mailto:kokusai@otani-shokai.com").mail E-mail: kokusai@otani-shokai.com
            br
            a.my-3.brown--text.lighten-3(href="http://www.otani-shokai.com/") www.otani-shokai.com
            br
            v-flex.px-2(xs12 sm6 offset-sm3)
              v-btn.mt-5.primary--text.px-5(
                href="mailto:kokusai@otani-shokai.com"
                color="secondary"
                block
                round
                depressed
                ) メールでのお問い合わせ

    CommonFooter
    span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="stylus">

img
  margin 0 auto
  width 200px
a
  text-decoration none

//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_chara_c.png) no-repeat
  background-position bottom 0 right -15px

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Contact/index.vue